module.exports = __webpack_public_path__ + "img/product-category-eternityrings.cbd9a71.webp";